import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { Icon } from "@/lib/ui";
import { Loader2 } from "lucide-react";
import Pager from "@/components/Pager";

const LIMIT = 24;

export default function AdminMessages() {
  const [data, setData] = useState(null);
  const [skip, setSkip] = useState(0);

  const load = useCallback(() => {
    api.get(`/admin/messages?skip=${skip}&limit=${LIMIT}`).then((r) => setData(r.data.data));
  }, [skip]);
  useEffect(() => { load(); }, [load]);

  return (
    <div className="space-y-6">
      <h1 className="font-display font-black text-3xl tracking-tight">Finder Messages</h1>
      {data === null ? <div className="py-16 grid place-items-center"><Loader2 className="w-6 h-6 animate-spin text-muted-foreground" /></div> :
        data.items.length === 0 ? <p className="text-muted-foreground">No finder messages yet.</p> :
        <div className="grid md:grid-cols-2 gap-4">
          {data.items.map((m) => (
            <div key={m.id} className="rounded-2xl border border-border bg-background p-5" data-testid="message-card">
              <div className="flex items-center justify-between">
                <p className="font-semibold">{m.finder_name}</p>
                <span className="text-xs font-bold px-2 py-1 rounded-full bg-[#EAF9EF] text-status-found">{m.status}</span>
              </div>
              <p className="text-xs text-muted-foreground font-mono mt-0.5">{m.tag_number} · {m.finder_phone}</p>
              <p className="text-sm mt-3">{m.message}</p>
              <div className="flex items-center gap-4 mt-3">
                <p className="text-xs text-muted-foreground">{new Date(m.created_at).toLocaleString()}</p>
                {m.maps_url && <a href={m.maps_url} target="_blank" rel="noreferrer" className="text-xs font-semibold text-status-found inline-flex items-center gap-1"><Icon name="MapPin" className="w-3.5 h-3.5" /> Location</a>}
              </div>
            </div>
          ))}
        </div>}
      {data && <Pager skip={skip} limit={LIMIT} total={data.total} onPage={setSkip} />}
    </div>
  );
}
